var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReelDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1415_6493)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7143 8.78516C13.1482 8.78516 13.5 9.13694 13.5 9.57087V11.928C13.5 12.7959 12.7965 13.4994 11.9286 13.4994H4.07143C3.20355 13.4994 2.5 12.7959 2.5 11.928V9.57087C2.5 9.13694 2.85178 8.78516 3.28571 8.78516C3.71965 8.78516 4.07143 9.13693 4.07143 9.57087V11.928H11.9286V9.57087C11.9286 9.13693 12.2803 8.78516 12.7143 8.78516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00003 2.5C8.43397 2.5 8.78575 2.85178 8.78575 3.28571V6.88883L9.8016 5.87298C10.1084 5.56615 10.6059 5.56615 10.9128 5.87298C11.2196 6.17983 11.2196 6.67731 10.9128 6.98416L8.00003 9.89687L5.08731 6.98416C4.78047 6.67731 4.78047 6.17983 5.08731 5.87298C5.39415 5.56615 5.89163 5.56615 6.19848 5.87298L7.21432 6.88883V3.28571C7.21432 2.85178 7.5661 2.5 8.00003 2.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_6493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelDown);
export default __webpack_public_path__ + "static/media/reel-down.28c3b6f4eacf6e7a50971bc06fb5c758.svg";
export { ForwardRef as ReactComponent };